module.exports = __webpack_public_path__ + "img/feature1.acbb761e.png";